import { Typography } from '@material-ui/core'
import RoomtypeIcon from '@material-ui/icons/MeetingRoom'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/RoomtypeAddHeader.styles'

export const RoomtypeAddHeader = () => {
  const classes = useStyles()
  const params = useParams<{ roomTypeId: string }>()

  return (
    <div className={classes.header}>
      <RoomtypeIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate(
          params.roomTypeId
            ? getTranslate('Edit Room Type')
            : getTranslate('Add New Room Type')
        )}
      </Typography>
    </div>
  )
}
